module.exports = __webpack_public_path__ + "static/media/profile-picture-6.874a8bf5.jpg";